var VoiesLyonnaisesMap = (function(){
  'use strict';

  var mapGL = null;
  var container = document.getElementById('voies-lyonnaises-map');
  var layers = [];

  var getLayerByName = function(name) {
    let layer = null;

    layers.forEach(function(item){
      if (item.getName() === name) {
        layer = item;
      }
    });

    return layer;
  };

  var init = function() {
    if (!maplibregl.supported()) {
      $(container).find('.maplibregl-unsupported').removeClass('is-hidden');
    } else {
      let zoom = 11;
      let minZoom = 9;
      let center =  [4.86, 45.76];
      let style = "/typo3conf/ext/gl_portailvelo_template/Resources/Public/MapLibreStyles/vector.json";
      let controls = {};

      if (window.matchMedia("(max-width: 767px)").matches) {
        controls = {
          navigation: {enable: 1, position: 'top-left'},
          geolocate: {enable: 1, position: 'top-left'},
        };
      } else {
        controls = {
          navigation: {enable: 1, position: 'bottom-right'},
          geolocate: {enable: 1, position: 'bottom-right'},
        };
      }

      mapGL = new MapGL(container, zoom, minZoom, center, style, controls);
      var mapObject = mapGL.getMapObject();

      mapObject.on('load', function() {

        let voieLyonnaiseLayer = new VoieLyonnaiseLayer(mapGL);

        layers = [
          voieLyonnaiseLayer
        ];

        $('#filters-map-control').removeClass('is-hidden');
        $('#legend-map-control').removeClass('is-hidden');

        $('#legend-map-control #js-map-show-legend').click(function () {
          $(this).toggleClass('is-active');
          if ($(this).hasClass('is-active')) {
            $('#legend-map-control #js-map-legend-panel').removeClass('is-hidden');
          } else {
            $('#legend-map-control #js-map-legend-panel').addClass('is-hidden');
          }
        });

        $('#legend-map-control #js-map-legend-close').click(function () {
          $('#legend-map-control #js-map-legend-panel').addClass('is-hidden');
          $('#legend-map-control #js-map-show-legend').removeClass('is-active');
        });

        $('#filters-map-control .js-map-filter').click(function () {
          var layerName = $(this).data('layer');
          var selectedLayer = getLayerByName(layerName);
          if (selectedLayer) {
            if ($(this).hasClass('is-active')) {
              selectedLayer.disable();
              $(this).removeClass('is-active');
            } else {
              selectedLayer.enable();
              $(this).addClass('is-active');
            }
          }

        });
      });
    }
  };

  return {
    init: init
  };

}());
